export default {
  login: {
    noSession: 'Votre session a expiré, veuillez vous reconnecter.',
  },
  chatbot: {
    title: 'Centre d’aide',
    you: 'Vous',
    messages: {
      welcome:
        'Bonjour {{ name }} ! Bienvenue dans le centre d’aide. Je suis disponible à tout moment pour vous aider sur l’utilisation de SKEZIA.',
      askQuestionOrConsultFaq: 'Vous pouvez me poser une question, ou bien simplement consulter la FAQ :',
    },
  },
  error: {
    UNKNOWN_ERROR: 'Erreur inconnue. Si le problème persiste, merci de contacter le support',
    INVALID_INPUTS: 'Les données envoyées dans le formulaire ne sont pas valides',
    EMAIL_ALREADY_USED: 'Email déjà utilisé',
    INVALID_CREDENTIALS_OR_NOT_CONFIRMED:
      "La combinaison de votre adresse e-mail et mot de passe est incorrecte. Si un compte a été créé mais n'a pas été validé, un email vous a été envoyé.",
    INVALID_CODE: 'Code invalide',
    INVALID_TOKEN: "Le Token fourni n'est pas valide",
    INVALID_PASSWORD: 'Mot de passe invalide',
    INVALID_OLD_PASSWORD: 'Le mot de passe actuel n’est pas valide',
    INVALID_AUTHORIZATION_TOKEN: "Le token d'autorisation n'est pas valide",
    APPLICATION_NOT_FOUND: 'Application non trouvée',
    INVALID_SECRET: 'Secret invalide',
    NICKNAME_ALEREADY_USED: 'Identifiant déjà utilisé',
    NO_VALID_SESSION: "Vous n'êtes pas connecté ou votre session a expiré",
    DOUBLE_AUTH_NOT_ENABLE: "La double authentification n'est pas activée sur votre compte. Veuillez vous reconnecter.",
    ALREADY_AUTHENTICATED: 'Vous êtes déjà connecté',
    OTP_COOLDOWN: 'Veuillez patienter quelques secondes avant de demander un nouveau code',
  },
  placeholder: {
    askQuestion: 'Posez votre question',
  },
  button: {
    viewFAQ: 'Consulter la FAQ',
    contactSupport: 'Contacter le support',
  },
};
